import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { INoahDeviceReadOut, NoahDeviceReadOutStatus } from 'gen/ApiClient';
import { QuickFilter } from '../NoahDeviceReadOutsList';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, INoahDeviceReadOut>, IQuickFilterContext<QuickFilter> {
	statusRecord: Record<NoahDeviceReadOutStatus, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
